export default __webpack_public_path__ + "static/media/feather.06c77b59.eot";